<template>
  <div id="loader-wrapper">
      <div id="loader"></div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
      <div class="load_title">
        自动登录授权中...
      </div>
    </div>
</template>

<script>
import {
  setToken,
 // getToken
} from '@/utils/cookies'
export default {
  name: 'AuthorizationView',
  data(){
    return {
        ppToken:null
    }
  },
  mounted(){
    
    //if (getToken()) {
    //  this.$router.push({ name: 'home' })
    //  return
    //}
    const query = this.$route.query
    if (query.pptoken && query.pptoken.length > 0) {
      setToken(query.pptoken)
      this.$router.push({ name: 'home' })
      return
    }
  }
}
</script>

<style>

</style>
